import { Dropdown } from 'react-bootstrap'
import { HorizontalStack, Icon } from '@ztechapps/webui.util'
import { useChatBubbleVisibilityContext } from '../../chat-bubble/Context'

export const ToggleChatBubbleDropdownItem = () => {
  const { isChatBubbleVisible, toggleChatBubbleVisible } = useChatBubbleVisibilityContext()

  return (
    <Dropdown.Item onClick={toggleChatBubbleVisible}>
      <HorizontalStack gap={1}>
        <Icon name={isChatBubbleVisible ? 'eye-slash' : 'eye'} />
        <span>{isChatBubbleVisible ? 'Hide' : 'Show'} chat bubble</span>
      </HorizontalStack>
    </Dropdown.Item>
  )
}
